import {lazy, Suspense} from "react";
import {Outlet, useLocation} from "react-router";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import GlobalLoading from "../components/GlobalLoading";
import PageCreateMandant from "./mandanten/PageCreateMandant";
import TableMandanten from "../components/mandanten/table/TableMandanten";
import PageUpdateMandant from "./mandanten/PageUpdateMandant";
import TableAufgaben from "../components/aufgaben/table/TableAufgaben";
import PageCreateAufgabe from "./aufgaben/PageCreateAufgabe";
import PageUpdateAufgabe from "./aufgaben/PageUpdateAufgabe";
import PageAufgabenTabs from "./aufgaben/PageAufgabenTabs";
import PageAufgabeVersions from "./aufgaben/PageAufgabeVersions";
import PageAufgabeScheduler from "./aufgaben/PageAufgabeScheduler";
import PageEditUnteraufgaben from "./unteraufgaben/PageEditUnteraufgaben";
import TableKontakteView from "../components/kontakte/table/TableKontakteView";
import PageCreateOnboardingCall from "./onboarding/PageCreateOnboardingCall";
import {AuthProvider} from "../auth";
import {UserProvider} from "../user";
import {PUBLIC_ROUTES} from "../config";
import PagePhonenumbers from "./phonenumbers/PagePhonenumbers";
import PagePhonenumberVersions from "./phonenumbers/PagePhonenumberVersions";
import PageTooling from "./tooling/PageTooling";
import TableSchedulers from "../components/schedulers/table/TableSchedulers";
import PageCreateScheduler from "./schedulers/PageCreateScheduler";
import PageUpdateScheduler from "./schedulers/PageUpdateScheduler";

// This is the root of the routing tree. Here we define all URL paths of the
// application and which components should be rendered when the user navigates
// to them.

export default function Pages() {
    return <RouterProvider router={useRouter()}/>;
}

// We load all pages lazily to minimize the bundle size. The code for each page
// will only be loaded once the page is first requested.
const Home = lazy(() => import("./Home"));
const NotFound = lazy(() => import("./NotFound"));

/**
 * Define the routing tree of the application.
 */
function useRouter() {
    return createBrowserRouter([
        {
            children: [
                {index: true, element: <Home/>},
                // Since this route comes last, it acts as a catch-all.
                {path: "*", element: <NotFound/>},
                {path: "mandanten", element: <TableMandanten/>},
                {path: "mandanten/new", element: <PageCreateMandant/>},
                {path: "mandanten/:mandantId", element: <PageUpdateMandant/>},
                {path: "aufgaben", element: <TableAufgaben/>},
                {path: "aufgaben/new", element: <PageCreateAufgabe/>},
                {
                    path: "aufgaben/:aufgabeId",
                    element: <PageAufgabenTabs/>,
                    children: [
                        {index: true, element: <PageUpdateAufgabe/>}, // default
                        {path: "details", element: <PageUpdateAufgabe/>},
                        {path: "versions", element: <PageAufgabeVersions/>},
                        {path: "unteraufgaben", element: <PageEditUnteraufgaben/>},
                        {path: "scheduler", element: <PageAufgabeScheduler/>},
                        {path: "kontakte", element: <TableKontakteView/>},
                    ],
                },
                {path: "phonenumbers", element: <PagePhonenumbers/>},
                {path: "phonenumbers/:phoneNumberId", element: <PagePhonenumberVersions/>},
                {path: "tooling", element: <PageTooling/>},
                {path: "schedulers", element: <TableSchedulers/>},
                {path: "schedulers/new", element: <PageCreateScheduler/>},
                {path: "schedulers/:schedulerId", element: <PageUpdateScheduler/>},
                {path: "testanruf", element: <PageCreateOnboardingCall/>},
            ],
            element: <PageLoader/>,
        },
    ]);
}

function PageLoader() {
    const location = useLocation();
    const isPublicRoute = PUBLIC_ROUTES.some(route =>
        location.pathname === route || location.pathname.startsWith(route + "/")
    );

    const content = <Outlet/>;

    return (
        <Suspense fallback={<GlobalLoading/>}>
            {isPublicRoute ? content : (
                <AuthProvider>
                    <UserProvider>{content}</UserProvider>
                </AuthProvider>
            )}
        </Suspense>
    );
}
